import { groupBy as kendoGroupBy , GroupDescriptor, orderBy as KendoOrderBy, SortDescriptor, aggregateBy as KendoAggregateBy, AggregateDescriptor } from "@progress/kendo-data-query";

export const groupBy = (data: any[], groupDescriptor: GroupDescriptor[]) => kendoGroupBy(data, groupDescriptor);

export const orderBy = <T>(data: T[], sortDescriptor: SortDescriptor[]): T[]  => KendoOrderBy(data, sortDescriptor);

export const aggregateBy = (data: any[], aggregateDescriptor: AggregateDescriptor[] ) => KendoAggregateBy(data, aggregateDescriptor)